import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const GuestPage = styled.main`
  width: 100%;
  max-width: 560px;
  margin: 0;
  box-sizing: border-box;
  padding: 38px 42px 42px;
  background: ${colors.white};
  border-radius: 16px;
  box-shadow: 0 18px 45px rgba(0, 48, 82, 0.22);
  color: ${colors.gray200};

  @media (max-width: 600px) {
    max-width: calc(100vw - 32px);
    margin: 0;
    padding: 28px 22px 30px;
  }
`;

export const Eyebrow = styled.div`
  margin-bottom: 10px;
  color: ${colors.primary};
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export const Title = styled.h1`
  margin: 0;
  color: ${colors.gray200};
  font-size: 27px;
  font-weight: 800;
  line-height: 1.15;
`;

export const Description = styled.p`
  margin: 12px 0 28px;
  color: ${colors.gray100};
  font-size: 15px;
  line-height: 1.5;
`;

export const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 14px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 7px;
  color: ${colors.gray200};
  font-size: 13px;
  font-weight: 700;
`;

export const FullWidthField = styled(Field)`
  grid-column: 1 / -1;
`;

export const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  height: 44px;
  padding: 0 13px;
  border: 1px solid #d8e0e8;
  border-radius: 8px;
  outline: none;
  background: #fbfcfe;
  color: ${colors.gray200};
  font-family: inherit;
  font-size: 14px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus {
    border-color: ${colors.primary};
    box-shadow: 0 0 0 3px rgba(0, 153, 255, 0.14);
    background: ${colors.white};
  }

  &::placeholder {
    color: #a2adb8;
  }
`;

export const Select = styled.select`
  width: 100%;
  box-sizing: border-box;
  height: 44px;
  padding: 0 13px;
  border: 1px solid #d8e0e8;
  border-radius: 8px;
  outline: none;
  background: #fbfcfe;
  color: ${colors.gray200};
  font-family: inherit;
  font-size: 14px;

  &:focus {
    border-color: ${colors.primary};
    box-shadow: 0 0 0 3px rgba(0, 153, 255, 0.14);
  }
`;

export const ErrorMessage = styled.p`
  grid-column: 1 / -1;
  margin: -2px 0 0;
  padding: 11px 13px;
  border-radius: 8px;
  background: #fff1f0;
  color: ${colors.red};
  font-size: 13px;
  line-height: 1.4;
`;

export const SubmitButton = styled.button`
  grid-column: 1 / -1;
  height: 46px;
  margin-top: 4px;
  border: 0;
  border-radius: 8px;
  background: ${colors.primary};
  color: ${colors.white};
  cursor: pointer;
  font-family: inherit;
  font-size: 15px;
  font-weight: 800;
  transition: background 0.15s ease, transform 0.15s ease;

  &:hover:not(:disabled) {
    background: #0087e0;
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: wait;
    opacity: 0.65;
  }
`;
